import React, { useState, useEffect } from "react"
import Icon from "../../../components/AppIcon"
import { Badge } from "../../../components/ui/badge"
import { listOrgCertificates } from "../../../utils/certHelpers"
import { getCohortLearners } from "../../../utils/cohortHelpers"

// Filters the org's certificates down to this cohort's learner userIds —
// mirrors getCourseCertificates/getProgramCertificates's org-wide-fetch-then-
// filter-in-memory pattern, no dedicated cohort-certificate join needed.
const CohortCredentialsTab = ({ orgId, cohort }) => {
  const [certificates, setCertificates] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      if (!orgId || !cohort?.cohortId) return
      setLoading(true)
      const [{ certificates: allCerts }, { enrollments }] = await Promise.all([
        listOrgCertificates(orgId),
        getCohortLearners(orgId, cohort?.cohortId, cohort?.courseId),
      ])
      const cohortUserIds = new Set(enrollments?.map((e) => e?.userId))
      setCertificates(allCerts?.filter((c) => cohortUserIds.has(c?.userId)) || [])
      setLoading(false)
    }
    load()
  }, [orgId, cohort?.cohortId, cohort?.courseId])

  if (loading) {
    return <div className="p-12 text-center text-muted-foreground text-sm">Loading credentials...</div>
  }

  if (certificates?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-12 text-center">
        <Icon name="Award" size={24} className="text-muted-foreground mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">No credentials issued to this cohort's learners yet.</p>
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {certificates?.map((cert) => (
        <div key={cert.certId} className="bg-card border border-border rounded-xl p-4 flex items-center justify-between gap-4">
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground">{cert.issuedTo}</p>
            <p className="text-xs text-muted-foreground">{cert.courseTitle}</p>
            <p className="text-xs text-muted-foreground mt-0.5">Issued {cert.issueDate?.slice(0, 10)} Â· Score {cert.score}%</p>
          </div>
          <Badge variant={cert.status === "valid" ? "success" : "secondary"} className="shrink-0">{cert.status}</Badge>
        </div>
      ))}
    </div>
  )
}

export default CohortCredentialsTab